import { render, staticRenderFns } from "./PropertyViewLogs.vue?vue&type=template&id=02511df5"
import script from "./PropertyViewLogs.vue?vue&type=script&lang=js"
export * from "./PropertyViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports